export default "__VITE_ASSET__WbA0HDJ1__"